// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","imageWrapper":"Home_imageWrapper__a5L65","image":"Home_image__dxFyw","name":"Home_name__GPsqW"};